<template>
  <div class="col-md-9 ms-sm-auto col-lg-10 px-md-4">
    <main>
      <div class="main_content align-items-center">
        <div class="row justify-content-between mb_40">
          <ClientHeaderTabs
            heading="Update Client"
            subheading="PBE Management Dashboard / Update Client / CMS"
            :tabs="tabs"
            :activeTab="activeTab"
            :handleTabClick="handleTabClick"
          />

          <form
            method="post"
            @submit.prevent="updateClientCMS"
            data-vv-scope="addCientForm"
          >
            <!-- Header Menus Section Start -->
            <div class="card site_footer mb_50">
              <div class="card_heading">
                <h4 class="heading2">Header Menu</h4>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="group_header">
                    <label class="hearder_menu_label" for="">Home</label>
                    <div class="form-group menu_cont">
                      <input
                        type="text"
                        placeholder="Custom Menu Text For Home"
                        name="home_menu_text"
                        id="home_menu_text"
                        class="form-control"
                        v-model="
                          client_data.site_menu_details.Home.custom_menu_text
                        "
                        v-validate="'required|max:20'"
                      />
                      <div
                        class="tab_report toggle_switch reported for_btn_cont"
                      >
                        <ul id="myTab1" class="nav nav-tabs">
                          <li class="nav-item">
                            <button
                              id="percent-tab1"
                              ref="Home_show"
                              @click="toggleHeaderMenu('Home', 1)"
                              data-bs-toggle="tab"
                              type="button"
                              aria-controls="percent"
                              aria-selected="true"
                              :class="
                                client_data.site_menu_details.Home.status == 1
                                  ? 'nav-link active'
                                  : 'nav-link'
                              "
                            >
                              Show
                            </button>
                          </li>
                          <li class="nav-item">
                            <button
                              id="hash-tab1"
                              @click="toggleHeaderMenu('Home', 0)"
                              data-bs-toggle="tab"
                              type="button"
                              aria-controls="hash"
                              aria-selected="false"
                              :class="
                                client_data.site_menu_details.Home.status == 0
                                  ? 'nav-link active'
                                  : 'nav-link'
                              "
                            >
                              Hide
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <small
                      class="error text-danger"
                      v-show="errors.has('addCientForm.home_menu_text')"
                    >
                      {{ errors.first("addCientForm.home_menu_text") }}
                    </small>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="group_header">
                    <label class="hearder_menu_label" for=""
                      >Ergo Essentials</label
                    >
                    <div class="form-group menu_cont">
                      <input
                        type="text"
                        placeholder="Custom Menu Text For Ergo Essentials"
                        name="ergo_menu_text"
                        id="ergo_menu_text"
                        class="form-control"
                        v-model="
                          client_data.site_menu_details.ErgoEssentials
                            .custom_menu_text
                        "
                        data-vv-as="Custom Menu Text For Ergo Essentials"
                        v-validate="'required|max:20'"
                      />
                      <div
                        class="tab_report toggle_switch reported for_btn_cont"
                      >
                        <ul id="myTab1" class="nav nav-tabs">
                          <li class="nav-item">
                            <button
                              id="percent-tab1"
                              ref="ErgoEssentials_show"
                              @click="toggleHeaderMenu('ErgoEssentials', 1)"
                              data-bs-toggle="tab"
                              type="button"
                              aria-controls="percent"
                              aria-selected="true"
                              :class="
                                client_data.site_menu_details.ErgoEssentials
                                  .status == 1
                                  ? 'nav-link active'
                                  : 'nav-link'
                              "
                            >
                              Show
                            </button>
                          </li>
                          <li class="nav-item">
                            <button
                              id="hash-tab1"
                              @click="toggleHeaderMenu('ErgoEssentials', 0)"
                              data-bs-toggle="tab"
                              type="button"
                              aria-controls="hash"
                              aria-selected="false"
                              :class="
                                client_data.site_menu_details.ErgoEssentials
                                  .status == 0
                                  ? 'nav-link active'
                                  : 'nav-link'
                              "
                            >
                              Hide
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <small
                      class="error text-danger"
                      v-show="errors.has('addCientForm.ergo_menu_text')"
                    >
                      {{ errors.first("addCientForm.ergo_menu_text") }}
                    </small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="group_header">
                    <label class="hearder_menu_label" for=""
                      >Setup Guidelines</label
                    >
                    <div class="form-group menu_cont">
                      <input
                        type="text"
                        placeholder="Custom Menu Text For Setup Guidelines"
                        name="guideline_menu_text"
                        id="guideline_menu_text"
                        class="form-control"
                        v-model="
                          client_data.site_menu_details.SetupGuidelines
                            .custom_menu_text
                        "
                        data-vv-as="Custom Menu Text For Setup Guidelines"
                        v-validate="'required|max:20'"
                      />
                      <div
                        class="tab_report toggle_switch reported for_btn_cont"
                      >
                        <ul id="myTab1" class="nav nav-tabs">
                          <li class="nav-item">
                            <button
                              id="percent-tab1"
                              ref="SetupGuidelines_show"
                              @click="toggleHeaderMenu('SetupGuidelines', 1)"
                              data-bs-toggle="tab"
                              type="button"
                              aria-controls="percent"
                              aria-selected="true"
                              :class="
                                client_data.site_menu_details.SetupGuidelines
                                  .status == 1
                                  ? 'nav-link active'
                                  : 'nav-link'
                              "
                            >
                              Show
                            </button>
                          </li>
                          <li class="nav-item">
                            <button
                              id="hash-tab1"
                              @click="toggleHeaderMenu('SetupGuidelines', 0)"
                              data-bs-toggle="tab"
                              type="button"
                              aria-controls="hash"
                              aria-selected="false"
                              :class="
                                client_data.site_menu_details.SetupGuidelines
                                  .status == 0
                                  ? 'nav-link active'
                                  : 'nav-link'
                              "
                            >
                              Hide
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <small
                      class="error text-danger"
                      v-show="errors.has('addCientForm.guideline_menu_text')"
                    >
                      {{ errors.first("addCientForm.guideline_menu_text") }}
                    </small>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="group_header">
                    <label class="hearder_menu_label" for="">Work Better</label>
                    <div class="form-group menu_cont">
                      <input
                        type="text"
                        placeholder="Custom Menu Text For Work Better"
                        name="work_better_menu_text"
                        id="work_better_menu_text"
                        class="form-control"
                        v-model="
                          client_data.site_menu_details.WorkBetter
                            .custom_menu_text
                        "
                        data-vv-as="Custom Menu Text For Work Better"
                        v-validate="'required|max:20'"
                      />
                      <div
                        class="tab_report toggle_switch reported for_btn_cont"
                      >
                        <ul id="myTab1" class="nav nav-tabs">
                          <li class="nav-item">
                            <button
                              id="percent-tab1"
                              ref="WorkBetter_show"
                              @click="toggleHeaderMenu('WorkBetter', 1)"
                              data-bs-toggle="tab"
                              type="button"
                              aria-controls="percent"
                              aria-selected="true"
                              :class="
                                client_data.site_menu_details.WorkBetter
                                  .status == 1
                                  ? 'nav-link active'
                                  : 'nav-link'
                              "
                            >
                              Show
                            </button>
                          </li>
                          <li class="nav-item">
                            <button
                              id="hash-tab1"
                              @click="toggleHeaderMenu('WorkBetter', 0)"
                              data-bs-toggle="tab"
                              type="button"
                              aria-controls="hash"
                              aria-selected="false"
                              :class="
                                client_data.site_menu_details.WorkBetter
                                  .status == 0
                                  ? 'nav-link active'
                                  : 'nav-link'
                              "
                            >
                              Hide
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <small
                      class="error text-danger"
                      v-show="errors.has('addCientForm.work_better_menu_text')"
                    >
                      {{ errors.first("addCientForm.work_better_menu_text") }}
                    </small>
                  </div>
                </div>
              </div>
              <!-- Videos and Manage Self-Assessment -->
              <div class="row">
                <div class="col-lg-6">
                  <div class="group_header">
                    <label class="hearder_menu_label" for="">Videos</label>
                    <div class="form-group menu_cont">
                      <input
                        type="text"
                        placeholder="Custom Menu Text For Videos"
                        name="videos_menu_text"
                        id="videos_menu_text"
                        class="form-control"
                        v-model="
                          client_data.site_menu_details.Videos.custom_menu_text
                        "
                        data-vv-as="Custom Menu Text For Videos"
                        v-validate="'required|max:20'"
                      />
                      <div
                        class="tab_report toggle_switch reported for_btn_cont"
                      >
                        <ul id="myTab1" class="nav nav-tabs">
                          <li class="nav-item">
                            <button
                              id="percent-tab1"
                              ref="Videos_show"
                              @click="toggleHeaderMenu('Videos', 1)"
                              data-bs-toggle="tab"
                              type="button"
                              aria-controls="percent"
                              aria-selected="true"
                              :class="
                                client_data.site_menu_details.Videos.status == 1
                                  ? 'nav-link active'
                                  : 'nav-link'
                              "
                            >
                              Show
                            </button>
                          </li>
                          <li class="nav-item">
                            <button
                              id="hash-tab1"
                              @click="toggleHeaderMenu('Videos', 0)"
                              data-bs-toggle="tab"
                              type="button"
                              aria-controls="hash"
                              aria-selected="false"
                              :class="
                                client_data.site_menu_details.Videos.status == 0
                                  ? 'nav-link active'
                                  : 'nav-link'
                              "
                            >
                              Hide
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <small
                      class="error text-danger"
                      v-show="errors.has('addCientForm.videos_menu_text')"
                    >
                      {{ errors.first("addCientForm.videos_menu_text") }}
                    </small>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="group_header">
                    <label class="hearder_menu_label" for=""
                      >Manage Self-Assessment</label
                    >
                    <div class="form-group menu_cont">
                      <input
                        type="text"
                        placeholder="Custom Menu Text For Take A Self-Assessment"
                        name="self_assessment_menu_text"
                        id="self_assessment_menu_text"
                        class="form-control"
                        v-model="
                          client_data.site_menu_details.TakeASelfAssessment
                            .custom_menu_text
                        "
                        data-vv-as="Custom Menu Text For Take A Self-Assessment"
                        v-validate="'required|max:25'"
                      />
                      <div
                        class="tab_report toggle_switch reported for_btn_cont"
                      >
                        <ul id="myTab1" class="nav nav-tabs">
                          <li class="nav-item">
                            <button
                              id="percent-tab1"
                              ref="TakeASelfAssessment_show"
                              @click="
                                toggleHeaderMenu('TakeASelfAssessment', 1)
                              "
                              data-bs-toggle="tab"
                              type="button"
                              aria-controls="percent"
                              aria-selected="true"
                              :class="
                                client_data.site_menu_details
                                  .TakeASelfAssessment.status == 1
                                  ? 'nav-link active'
                                  : 'nav-link'
                              "
                            >
                              Show
                            </button>
                          </li>
                          <li class="nav-item">
                            <button
                              id="hash-tab1"
                              @click="
                                toggleHeaderMenu('TakeASelfAssessment', 0)
                              "
                              data-bs-toggle="tab"
                              type="button"
                              aria-controls="hash"
                              aria-selected="false"
                              :class="
                                client_data.site_menu_details
                                  .TakeASelfAssessment.status == 0
                                  ? 'nav-link active'
                                  : 'nav-link'
                              "
                            >
                              Hide
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <small
                      class="error text-danger"
                      v-show="
                        errors.has('addCientForm.self_assessment_menu_text')
                      "
                    >
                      {{
                        errors.first("addCientForm.self_assessment_menu_text")
                      }}
                    </small>
                  </div>
                </div>
              </div>
              <!-- Request An Evaluation -->
              <div class="row">
                <div class="col-lg-6">
                  <div class="group_header">
                    <label class="hearder_menu_label" for=""
                      >Request An Evaluation</label
                    >
                    <div class="form-group menu_cont">
                      <input
                        type="text"
                        placeholder="Custom Menu Text For Request An Evaluation"
                        name="request_an_evaluation_menu_text"
                        id="request_an_evaluation_menu_text"
                        class="form-control"
                        v-model="
                          client_data.site_menu_details.RequestAnEvaluation
                            .custom_menu_text
                        "
                        data-vv-as="Custom Menu Text For RequestAnEvaluation"
                        v-validate="'required|max:25'"
                      />
                      <div
                        class="tab_report toggle_switch reported for_btn_cont"
                      >
                        <ul id="myTab1" class="nav nav-tabs">
                          <li class="nav-item">
                            <button
                              id="percent-tab1"
                              ref="RequestAnEvaluation_show"
                              @click="
                                toggleHeaderMenu('RequestAnEvaluation', 1)
                              "
                              data-bs-toggle="tab"
                              type="button"
                              aria-controls="percent"
                              aria-selected="true"
                              :class="
                                client_data.site_menu_details
                                  .RequestAnEvaluation.status == 1
                                  ? 'nav-link active'
                                  : 'nav-link'
                              "
                            >
                              Show
                            </button>
                          </li>
                          <li class="nav-item">
                            <button
                              id="hash-tab1"
                              @click="
                                toggleHeaderMenu('RequestAnEvaluation', 0)
                              "
                              data-bs-toggle="tab"
                              type="button"
                              aria-controls="hash"
                              aria-selected="false"
                              :class="
                                client_data.site_menu_details
                                  .RequestAnEvaluation.status == 0
                                  ? 'nav-link active'
                                  : 'nav-link'
                              "
                            >
                              Hide
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <small
                      class="error text-danger"
                      v-show="
                        errors.has(
                          'addCientForm.request_an_evaluation_menu_text'
                        )
                      "
                    >
                      {{
                        errors.first(
                          "addCientForm.request_an_evaluation_menu_text"
                        )
                      }}
                    </small>
                  </div>
                </div>
              </div>
              <div
                class="row"
              >
                <div class="editor_heading">
                  <div class="form-group">
                    <label for="schedule_assessment_title" class="form-label"
                      >Schedule Your Ergonomic Assessment Heading</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="schedule_assessment_title"
                      name="schedule_assessment_title"
                      placeholder="Enter Schedule Eval Title"
                      v-model="client_data.schedule_assessment_title"
                      v-validate="'required|max:50'"
                      data-vv-as="Schedule Eval Title"
                    />
                    <small
                      class="error text-danger"
                      v-show="
                        errors.has('addCientForm.schedule_assessment_title')
                      "
                    >
                      {{
                        errors.first("addCientForm.schedule_assessment_title")
                      }}
                    </small>
                  </div>
                </div>
                <div class="px_10">
                  <div class="form-group">
                    <label
                      for="schedule_assessment_description"
                      class="form-label"
                      >Schedule Your Ergonomic Assessment Content</label
                    >

                    <ckeditor
                      id="schedule_assessment_description"
                      name="schedule_assessment_description"
                      :editor="editor"
                      v-model="client_data.schedule_assessment_description"
                      :config="editorConfig"
                      v-validate="'required|max:400'"
                      data-vv-as="Schedule Eval Description"
                    ></ckeditor>
                    <small
                      class="error text-danger"
                      v-show="
                        errors.has(
                          'addCientForm.schedule_assessment_description'
                        )
                      "
                    >
                      {{
                        errors.first(
                          "addCientForm.schedule_assessment_description"
                        )
                      }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <!-- Header Menus Section End -->
            <!-- Work from Areas Component Start -->
            <ClientWorkFromAreas
              ref="ClientWorkFromAreas"
              v-bind:client_data="client_data"
              v-bind:base_url="base_url"
            ></ClientWorkFromAreas>
            <!-- Work from Areas Component End -->
            <!-- Help center Component Start -->
            <ClientHelpCenter
              ref="ClientHelpCenter"
              v-bind:help_center_details="client_data.help_center_details"
              v-bind:clientId="client_data.id"
              v-bind:base_url="base_url"
            ></ClientHelpCenter>
            <!-- Help center Component End -->
            <!-- Video Playlist Section Start -->
            <div class="third-section card site_footer mb_50">
              <div class="card_heading">
                <h4 class="heading2">Video Playlist</h4>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="sitefooter-checkbox">
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Everyday Stretches"
                        aria-label="..."
                        id="vples"
                        class="form-check-input"
                        v-model="client_data.video_playlist"
                      /><label for="vples"> Everyday Stretches</label>
                    </div>
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Ergo Essentials"
                        aria-label="..."
                        id="vplee"
                        class="form-check-input"
                        v-model="client_data.video_playlist"
                      /><label for="vplee"> Ergo Essentials </label>
                    </div>
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Healthy Living"
                        aria-label="..."
                        id="vplhl"
                        class="form-check-input"
                        v-model="client_data.video_playlist"
                      /><label for="vplhl"> Healthy Living </label>
                    </div>
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Yoga Exercise"
                        aria-label="..."
                        id="vplye"
                        class="form-check-input"
                        v-model="client_data.video_playlist"
                      /><label for="vplye"> Yoga Exercise </label>
                    </div>
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Productivity Hacks"
                        aria-label="..."
                        id="vplph"
                        class="form-check-input"
                        v-model="client_data.video_playlist"
                      /><label for="vplph"> Productivity Hacks </label>
                    </div>
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Posture Perfect"
                        aria-label="..."
                        id="vplpp"
                        class="form-check-input"
                        v-model="client_data.video_playlist"
                      /><label for="vplpp"> Posture Perfect </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Video Playlist Section End -->
            <!-- Ergo Essential Section Start -->
            <div class="third-section card site_footer mb_50">
              <div class="card_heading">
                <h4 class="heading2">Ergo Essentials</h4>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="col-lg-6">
                    <div class="group_header">
                      <label class="hearder_menu_label" for="">Heading</label>
                      <input
                        type="text"
                        placeholder="Ergo Essentials Heading"
                        name="ergo_essentials_heading"
                        id="ergo_essentials_heading"
                        class="form-control"
                        v-model="client_data.ergo_essentials_heading"
                        v-validate="'max:50'"
                        data-vv-as="Ergo essentials heading"
                      />
                      <span
                        class="text-danger"
                        v-show="
                          errors.has('addCientForm.ergo_essentials_heading')
                        "
                      >
                        {{
                          errors.first("addCientForm.ergo_essentials_heading")
                        }}
                      </span>
                    </div>
                  </div>
                  <div class="sitefooter-checkbox">
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Posture Perfect"
                        aria-label="..."
                        id="eepp"
                        class="form-check-input"
                        v-model="client_data.ergo_essentials"
                      /><label for="eepp">Posture Perfect</label>
                    </div>
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Sitting Pretty"
                        aria-label="..."
                        id="eesp"
                        class="form-check-input"
                        v-model="client_data.ergo_essentials"
                      /><label for="eesp">Sitting Pretty</label>
                    </div>
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Sit/Stand Basics"
                        aria-label="..."
                        id="eesb"
                        class="form-check-input"
                        v-model="client_data.ergo_essentials"
                      /><label for="eesb">Sit/Stand Basics</label>
                    </div>
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Typing Do’s and Don’ts"
                        aria-label="..."
                        id="eetd"
                        class="form-check-input"
                        v-model="client_data.ergo_essentials"
                      /><label for="eetd">Typing Do’s and Don’ts</label>
                    </div>
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Mousing Do’s and Don’ts"
                        aria-label="..."
                        id="eemd"
                        class="form-check-input"
                        v-model="client_data.ergo_essentials"
                      /><label for="eemd">Mousing Do’s and Don’ts</label>
                    </div>
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Mindful Ergonomics"
                        aria-label="..."
                        id="eeme"
                        class="form-check-input"
                        v-model="client_data.ergo_essentials"
                      /><label for="eeme">Mindful Ergonomics</label>
                    </div>
                  </div>
                  <input
                    type="hidden"
                    name="ergo_essentials"
                    v-validate="'required'"
                    :value="client_data.ergo_essentials.length ? 'valid' : ''"
                    data-vv-as="Ergo Essentials"
                  />
                  <span
                    class="text-danger"
                    v-show="errors.has('addCientForm.ergo_essentials')"
                  >
                    {{ errors.first("addCientForm.ergo_essentials") }}
                  </span>
                </div>
              </div>
            </div>
            <!-- Ergo Essential Section End -->
            <!-- Setup Guidelines Section Start -->
            <div class="third-section card site_footer mb_50">
              <div class="card_heading">
                <h4 class="heading2">Setup Guidelines</h4>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="col-lg-6">
                    <div class="group_header">
                      <label class="hearder_menu_label" for="">Heading</label>
                      <input
                        type="text"
                        placeholder="Setup Guidelines Heading"
                        name="setup_guidelines_heading"
                        id="setup_guidelines_heading"
                        class="form-control"
                        v-model="client_data.setup_guidelines_heading"
                        v-validate="'max:50'"
                        data-vv-as="Setup guidelines heading"
                      />
                      <span
                        class="text-danger"
                        v-show="
                          errors.has('addCientForm.setup_guidelines_heading')
                        "
                      >
                        {{
                          errors.first("addCientForm.setup_guidelines_heading")
                        }}
                      </span>
                    </div>
                  </div>
                  <div class="sitefooter-checkbox">
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Seating"
                        aria-label="..."
                        id="sgseating"
                        class="form-check-input"
                        v-model="client_data.setup_guidelines"
                      /><label for="sgseating">Seating</label>
                    </div>
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Desk"
                        aria-label="..."
                        id="sgdesk"
                        class="form-check-input"
                        v-model="client_data.setup_guidelines"
                      /><label for="sgdesk">Desk</label>
                    </div>
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Desktop items"
                        aria-label="..."
                        id="sgdesktop"
                        class="form-check-input"
                        v-model="client_data.setup_guidelines"
                      /><label for="sgdesktop">Desktop items</label>
                    </div>
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Screens"
                        aria-label="..."
                        id="sgscreens"
                        class="form-check-input"
                        v-model="client_data.setup_guidelines"
                      /><label for="sgscreens">Screens</label>
                    </div>
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Accessories"
                        aria-label="..."
                        id="sgaccessories"
                        class="form-check-input"
                        v-model="client_data.setup_guidelines"
                      /><label for="sgaccessories">Accessories</label>
                    </div>
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Lighting"
                        aria-label="..."
                        id="sglighting"
                        class="form-check-input"
                        v-model="client_data.setup_guidelines"
                      /><label for="sglighting">Lighting</label>
                    </div>
                  </div>
                  <input
                    type="hidden"
                    name="setup_guidelines"
                    v-validate="'required'"
                    :value="client_data.setup_guidelines.length ? 'valid' : ''"
                    data-vv-as="Setup Guidelines"
                  />
                  <span
                    class="text-danger"
                    v-show="errors.has('addCientForm.setup_guidelines')"
                  >
                    {{ errors.first("addCientForm.setup_guidelines") }}
                  </span>
                </div>
              </div>
            </div>
            <!-- Setup Guidelines Section End -->
            <!-- Lab Training Section Start -->
            <div class="third-section card site_footer mb_50">
              <div class="card_heading">
                <h4 class="heading2">Lab Training</h4>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="group_header">
                    <label class="hearder_menu_label" for=""
                      >Home: Lab Training</label
                    >
                    <v-select
                      v-model="client_data.lab_training_status"
                      label="name"
                      name="status"
                      :reduce="(status_list) => status_list.id"
                      :options="status_list"
                      placeholder="Select Status"
                      v-validate="'required'"
                      data-vv-as="lab_training_status"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="sitefooter-checkbox">
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Bench Work"
                        aria-label="..."
                        id="ltbench"
                        class="form-check-input"
                        v-model="client_data.lab_training"
                      /><label for="ltbench">Bench Work</label>
                    </div>
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Pipetting"
                        aria-label="..."
                        id="ltpipetting"
                        class="form-check-input"
                        v-model="client_data.lab_training"
                      /><label for="ltpipetting">Pipetting</label>
                    </div>
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Microscopes"
                        aria-label="..."
                        id="ltmicroscopes"
                        class="form-check-input"
                        v-model="client_data.lab_training"
                      /><label for="ltmicroscopes">Microscopes</label>
                    </div>
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Material Handling"
                        aria-label="..."
                        id="ltmaterial"
                        class="form-check-input"
                        v-model="client_data.lab_training"
                      /><label for="ltmaterial">Material Handling</label>
                    </div>
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Hood Work"
                        aria-label="..."
                        id="lthood"
                        class="form-check-input"
                        v-model="client_data.lab_training"
                      /><label for="lthood">Hood Work</label>
                    </div>
                    <div
                      class="form_check_box d-inline-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value="Lab Stretches"
                        aria-label="..."
                        id="ltstretches"
                        class="form-check-input"
                        v-model="client_data.lab_training"
                      /><label for="ltstretches">Lab Stretches</label>
                    </div>
                  </div>
                  <input
                    type="hidden"
                    name="lab_training"
                    v-validate="'required'"
                    :value="client_data.lab_training.length ? 'valid' : ''"
                    data-vv-as="Lab Training"
                  />
                  <span
                    class="text-danger"
                    v-show="errors.has('addCientForm.lab_training')"
                  >
                    {{ errors.first("addCientForm.lab_training") }}
                  </span>
                </div>
              </div>
            </div>
            <!-- Setup Guidelines Section End -->
            <!-- Schedule Request -->
            <div class="card mb_32">
              <div class="editor_heading">
                <div class="form_check_box d-flex align-items-center pb_20">
                  <input
                    type="checkbox"
                    value=""
                    aria-label="..."
                    id="schedulerequestcheck"
                    class="form-check-input"
                    v-model="client_data.schedule_request_status"
                  />
                  <label for="schedulerequestcheck"> Schedule Request</label>
                </div>
              </div>
              <div class="px_10">
                <div class="form-group mb_20">
                  <label for="schedule_request_heading" class="form-label"
                    >Already completed a self-assessment?</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="schedule_request_heading"
                    name="schedule_request_heading"
                    placeholder="Enter heading for schedule request"
                    v-model="client_data.schedule_request_heading"
                    v-validate="
                      client_data.schedule_request_status
                        ? 'required|max:100'
                        : 'max:100'
                    "
                    data-vv-as="Schedule Request Heading"
                  />
                  <small
                    class="error text-danger"
                    v-show="errors.has('addCientForm.schedule_request_heading')"
                  >
                    {{ errors.first("addCientForm.schedule_request_heading") }}
                  </small>
                </div>
                <ckeditor
                  id="schedule_request_details"
                  name="schedule_request_details"
                  :editor="editor"
                  v-model="client_data.schedule_request"
                  :config="editorConfig"
                  v-validate="'required'"
                  data-vv-as="Schedule Request details"
                  @blur="
                    onLostFocusEditor('addCientForm.schedule_request_details')
                  "
                ></ckeditor>
                <small
                  class="error text-danger"
                  v-show="errors.has('addCientForm.schedule_request_details')"
                >
                  {{ errors.first("addCientForm.schedule_request_details") }}
                </small>
              </div>
              <div class="form-group mb_20 mt_20">
                <label for="self_assessment_heading" class="form-label"
                  >Have you taken your self-assessment?</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="self_assessment_heading"
                  name="self_assessment_heading"
                  placeholder="Enter heading for self-assessment"
                  v-model="client_data.self_assessment_heading"
                  v-validate="'required|max:100'"
                  data-vv-as="Self-Assessment Heading"
                />
                <small
                  class="error text-danger"
                  v-show="errors.has('addCientForm.self_assessment_heading')"
                >
                  {{ errors.first("addCientForm.self_assessment_heading") }}
                </small>
              </div>
              <div class="form-group">
                <label for="self_assessment_content" class="form-label"
                  >Self-Assessment Content</label
                >
                <ckeditor
                  id="self_assessment_content"
                  name="self_assessment_content"
                  :editor="editor"
                  v-model="client_data.self_assessment_content"
                  :config="editorConfig"
                  data-vv-as="Self-Assessment Content"
                  v-validate="'required'"
                  @blur="
                    onLostFocusEditor('addCientForm.self_assessment_content')
                  "
                ></ckeditor>
                <small
                  class="error text-danger"
                  v-show="errors.has('addCientForm.self_assessment_content')"
                >
                  {{ errors.first("addCientForm.self_assessment_content") }}
                </small>
              </div>
            </div>
            <!-- Schedule Request End -->
            <!-- Lab Training Section End -->
            <div class="row">
              <div class="site_footer">
                <div class="client_btn_group action_btn">
                  <div class="row mt_24 justify-content-start">
                    <div class="col-md-10 col-lg-6 col-xl-4 text-start">
                      <button type="submit" class="btn btn_primary">
                        Update
                      </button>
                      <router-link :to="{ name: 'all_clients' }">
                        <button
                          href="javascript:void(0);"
                          class="btn btn_outline ml_24"
                        >
                          Cancel
                        </button>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </main>
    <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  </div>
</template>
<script>
import ClassicEditor from "ckeditor5-build-classic-image";
import ClientWorkFromAreas from "@/components/clients/ClientWorkFromAreas.vue";
import ClientHelpCenter from "@/components/clients/ClientHelpCenter.vue";
import ConfirmDialogue from "@/components/ConfirmDialogue";
import commonFunction from "../../../mixin/commonFunction";
import ClientHeaderTabs from "../../../components/ClientHeaderTabs.vue";
export default {
  provide() {
    return { parentValidator: this.$validator };
  },
  name: "Client_CMS",
  components: {
    ConfirmDialogue,
    ClientWorkFromAreas,
    ClientHelpCenter,
    ClientHeaderTabs,
  },
  mixins: [commonFunction],
  watch: {
    // Watch for route changes and update activeTab accordingly
    $route(to) {
      switch (to.name) {
        case "edit_client":
          this.activeTab = "update-client";
          break;
        case "edit_client_self_assessment_en":
          this.activeTab = "self-assessment";
          break;
        case "edit_client_ergo_eval_en":
          this.activeTab = "ergo-eval";
          break;
        case "edit_client_self_assessment_lab":
          this.activeTab = "self-assessment-lab";
          break;
        case "edit_client_ergo_eval_lab":
          this.activeTab = "ergo-eval-lab";
          break;
        case "edit_client_cms":
          this.activeTab = "cms";
          break;
        default:
          this.activeTab = "update-client";
      }
    },
  },
  data() {
    return {
      activeTab: "cms",
      provide() {
        return { parentValidator: this.$validator };
      },
      tabs: [
        { id: "update-client", label: "Update Client" },
        { id: "cms", label: "CMS" },
        { id: "self-assessment", label: "Self-Assessment" },
        { id: "ergo-eval", label: "Ergo Eval" },
        { id: "self-assessment-lab", label: "Self-Assessment - Lab" },
        { id: "ergo-eval-lab", label: "Ergo Eval - Lab" },
      ],
      //   summaryReportInfo: this.$store.getters["ClientsConfig/summaryReportInfo"],
      editor: ClassicEditor,
      editorData:
        "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>",
      editorConfig: {
        // The configuration of the editor.
        toolbar: {
          items: [
            "heading",
            "|",
            "bold",
            "italic",
            "fontColor",
            "fontBackgroundColor",
            "link",
            "|",
            "undo",
            "redo",
            "alignment",
          ],
        },
        link: {
          // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
          addTargetToExternalLinks: true,
        },
      },
      base_url: null,
      status_list: [
        {
          id: 1,
          name: "Show",
        },
        {
          id: 0,
          name: "Hide",
        },
      ],
      client_data: {
        id: "",
        u_id: "",
        site_menu_details: {
          Home: {
            menu: "Home",
            custom_menu_text: "Home",
            status: 1,
          },
          ErgoEssentials: {
            menu: "Ergo Essentials",
            custom_menu_text: "Ergo Essentials",
            status: 1,
          },
          SetupGuidelines: {
            menu: "Setup Guidelines",
            custom_menu_text: "Setup Guidelines",
            status: 1,
          },
          WorkBetter: {
            menu: "Work Better",
            custom_menu_text: "Work Better",
            status: 1,
          },
          Videos: {
            menu: "Videos",
            custom_menu_text: "Videos",
            status: 1,
          },
          TakeASelfAssessment: {
            menu: "Take A Self-Assessment",
            custom_menu_text: "Take A Self-Assessment",
            status: 1,
          },
          RequestAnEvaluation: {
            menu: "Request An Evaluation",
            custom_menu_text: "Request An Evaluation",
            status: 0,
          },
        },
        work_area: [],
        work_from_office: false,
        work_from_home: false,
        new_work_from_home_icon: false,
        new_work_from_office_icon: false,
        new_work_from_anywhere_icon: false,
        new_work_from_lab_icon: false,
        work_from_anywhere: false,
        work_from_lab: false,
        work_from_travel: false,
        work_area_details: {
          Office: {
            oldIcon: require("@/assets/images/homepage/office.png"),
            icon: require("@/assets/images/homepage/office.png"),
            title: "Working from office?",
            description:
              "Discover your ideal setup, learn the best ergo practices and be on your A game every single day.",
          },
          Home: {
            oldIcon: require("@/assets/images/homepage/home.png"),
            icon: require("@/assets/images/homepage/home.png"),
            title: "Working from home?",
            description:
              "Discover the best ways to bring ergo into your home, boost your productivity and feel great!",
          },
          Anywhere: {
            oldIcon: require("@/assets/images/homepage/anywhere.png"),
            icon: require("@/assets/images/homepage/anywhere.png"),
            title: "Working from anywhere?",
            description:
              "Hello Hybrid.  Shuttling back and forth between the office and home? We’ve got you.",
          },
          Lab: {
            oldIcon: require("@/assets/images/homepage/lab.png"),
            icon: require("@/assets/images/homepage/lab.png"),
            title: "Working from lab?",
            description:
              "Learn how to navigate the variety of working environments inherent in labs to feel great.",
          },
          Travel: {
            oldIcon: require("@/assets/images/homepage/travel-for-work-home.png"),
            icon: require("@/assets/images/homepage/travel-for-work-home.png"),
            title: "Do you travel for work?",
            description:
              "Stay on your A-game with good ergo and healthy work practices no matter where you are.",
          },
        },
        help_center_details: {
          GeneralErgo: {
            default_heading: "General Ergo",
            heading: "General Ergo",
            status: 1,
            data: [
              {
                question: "",
                answer: "",
                icon: "",
                oldIcon: "",
                newIcon: false,
              },
            ],
          },
          MyReports: {
            default_heading: "My Reports",
            heading: "My Reports",
            status: 1,
            data: [
              {
                question: "",
                answer: "",
                icon: "",
                oldIcon: "",
                newIcon: false,
              },
            ],
          },
          MyData: {
            default_heading: "My Data",
            heading: "My Data",
            status: 1,
            data: [
              {
                question: "",
                answer: "",
                icon: "",
                oldIcon: "",
                newIcon: false,
              },
            ],
          },
          AdditionalSupport: {
            default_heading: "Additional Support",
            heading: "Additional Support",
            status: 1,
            data: [
              {
                question: "",
                answer: "",
                icon: "",
                oldIcon: "",
                newIcon: false,
              },
            ],
          },
          DashboardTutorials: {
            default_heading: "Dashboard Tutorials",
            heading: "Dashboard Tutorials",
            status: 1,
            data: [
              {
                question: "",
                answer: "",
                icon: "",
                oldIcon: "",
                newIcon: false,
                vimeoVideos: [],
              },
            ],
          },
        },
        video_playlist: [
          "Everyday Stretches",
          "Ergo Essentials",
          "Healthy Living",
          "Yoga Exercise",
          "Productivity Hacks",
          "Posture Perfect",
        ],
        ergo_essentials: [
          "Posture Perfect",
          "Sitting Pretty",
          "Sit/Stand Basics",
          "Typing Do’s and Don’ts",
          "Mousing Do’s and Don’ts",
          "Mindful Ergonomics",
        ],
        ergo_essentials_heading: "",
        setup_guidelines: [
          "Seating",
          "Desk",
          "Desktop items",
          "Screens",
          "Accessories",
          "Lighting",
        ],
        setup_guidelines_heading: "",
        lab_training: [
          "Bench Work",
          "Pipetting",
          "Microscopes",
          "Material Handling",
          "Hood Work",
          "Lab Stretches",
        ],
        lab_training_status: 0,
        schedule_request_heading: "",
        self_assessment_heading: "",
        self_assessment_content: "",
      },
    };
  },
  beforeMount() {
    this.getSingleClient(this.$route.params.id);
  },
  mounted() {
    this.base_url = process.env.VUE_APP_API_URL;
  },
  methods: {
    handleTabClick(tab) {
      this.$parent.$refs.fullpageloader.is_full_page_loader = true;
      this.activeTab = tab.id;

      const clientId = this.$route.params.id;
      switch (tab.id) {
        case "edit-client":
          this.$router
            .push({
              name: "edit_client",
              params: { id: clientId },
            })
            .then(() => {
              this.$parent.$refs.fullpageloader.is_full_page_loader = false;
            });
          break;
        case "self-assessment":
          this.$router
            .push({
              name: "edit_client_self_assessment_en",
              params: { id: clientId },
            })
            .then(() => {
              this.$parent.$refs.fullpageloader.is_full_page_loader = false;
            });
          break;
        case "ergo-eval":
          this.$router
            .push({
              name: "edit_client_ergo_eval_en",
              params: { id: clientId },
            })
            .then(() => {
              this.$parent.$refs.fullpageloader.is_full_page_loader = false;
            });
          break;
        case "self-assessment-lab":
          this.$router
            .push({
              name: "edit_client_self_assessment_lab",
              params: { id: clientId },
            })
            .then(() => {
              this.$parent.$refs.fullpageloader.is_full_page_loader = false;
            });
          break;
        case "ergo-eval-lab":
          this.$router
            .push({
              name: "edit_client_ergo_eval_lab",
              params: { id: clientId },
            })
            .then(() => {
              this.$parent.$refs.fullpageloader.is_full_page_loader = false;
            });
          break;
        default:
          this.$router
            .push({
              name: "edit_client",
              params: { id: clientId },
            })
            .then(() => {
              this.$parent.$refs.fullpageloader.is_full_page_loader = false;
            });
      }
    },
    onLostFocusEditor(id) {
      this.onLostFocusEditor(id);
    },
    getSingleClient(id) {
      var _this = this;
      let config = {
        method: "get",
        url: process.env.VUE_APP_API_URL + "/api/edit-client-cms/" + id,
        withCredentials: true,
      };
      _this
        .axios(config)
        .then(({ data }) => {
          if (data.success) {
            var decodedData = _this.decodeAPIResponse(data.data);
            console.log("decodedData", decodedData);
            _this.client_data.id = this.$route.params.id;
            _this.client_data.u_id = this.$route.params.id;
            _this.client_data.work_area = decodedData.records.work_area;
            _this.client_data.work_from_office =
              decodedData.records.work_from_office;
            _this.client_data.work_from_home =
              decodedData.records.work_from_home;
            _this.client_data.work_from_anywhere =
              decodedData.records.work_from_anywhere;
            _this.client_data.work_from_lab = decodedData.records.work_from_lab;
            _this.client_data.work_from_travel =
              decodedData.records.work_from_travel;
            if (
              decodedData.records.work_area.length &&
              decodedData.records.work_area_details != undefined
            ) {
              if (decodedData.records.work_area_details.Office != undefined) {
                _this.client_data.work_area_details.Office =
                  decodedData.records.work_area_details.Office;
                _this.client_data.work_area_details.Office.oldIcon =
                  decodedData.records.work_area_details.Office.icon;
              }
              if (decodedData.records.work_area_details.Home != undefined) {
                _this.client_data.work_area_details.Home =
                  decodedData.records.work_area_details.Home;
                _this.client_data.work_area_details.Home.oldIcon =
                  decodedData.records.work_area_details.Home.icon;
              }
              if (decodedData.records.work_area_details.Anywhere != undefined) {
                _this.client_data.work_area_details.Anywhere =
                  decodedData.records.work_area_details.Anywhere;
                _this.client_data.work_area_details.Anywhere.oldIcon =
                  decodedData.records.work_area_details.Anywhere.icon;
              }
              if (decodedData.records.work_area_details.Lab != undefined) {
                _this.client_data.work_area_details.Lab =
                  decodedData.records.work_area_details.Lab;
                _this.client_data.work_area_details.Lab.oldIcon =
                  decodedData.records.work_area_details.Lab.icon;
              }
              if (decodedData.records.work_area_details.Travel != undefined) {
                _this.client_data.work_area_details.Travel =
                  decodedData.records.work_area_details.Travel;
                _this.client_data.work_area_details.Travel.oldIcon =
                  decodedData.records.work_area_details.Travel.icon;
              }
            }
            if (decodedData.records.site_menu_details != undefined) {
              if (decodedData.records.site_menu_details.Home != undefined) {
                _this.client_data.site_menu_details.Home =
                  decodedData.records.site_menu_details.Home;
              }
              if (
                decodedData.records.site_menu_details.WorkBetter != undefined
              ) {
                _this.client_data.site_menu_details.WorkBetter =
                  decodedData.records.site_menu_details.WorkBetter;
              }
              if (
                decodedData.records.site_menu_details.SetupGuidelines !=
                undefined
              ) {
                _this.client_data.site_menu_details.SetupGuidelines =
                  decodedData.records.site_menu_details.SetupGuidelines;
              }
              if (decodedData.records.site_menu_details.Videos != undefined) {
                _this.client_data.site_menu_details.Videos =
                  decodedData.records.site_menu_details.Videos;
              }
              if (
                decodedData.records.site_menu_details.ErgoEssentials !=
                undefined
              ) {
                _this.client_data.site_menu_details.ErgoEssentials =
                  decodedData.records.site_menu_details.ErgoEssentials;
              }
              if (
                decodedData.records.site_menu_details.TakeASelfAssessment !=
                undefined
              ) {
                _this.client_data.site_menu_details.TakeASelfAssessment =
                  decodedData.records.site_menu_details.TakeASelfAssessment;
              }
              if (
                decodedData.records.site_menu_details.RequestAnEvaluation !=
                undefined
              ) {
                _this.client_data.site_menu_details.RequestAnEvaluation =
                  decodedData.records.site_menu_details.RequestAnEvaluation;
              }
            }
            if (decodedData.records.help_center_details != undefined) {
              _this.client_data.help_center_details =
                decodedData.records.help_center_details;
            }

            _this.client_data.video_playlist =
              decodedData.records.video_playlist;

            _this.client_data.ergo_essentials =
              decodedData.records.essentials.ergo_essentials_options;
            _this.client_data.ergo_essentials_heading =
              decodedData.records.essentials.ergo_essentials_heading;

            _this.client_data.setup_guidelines =
              decodedData.records.essentials.setup_guidelines_options;
            _this.client_data.setup_guidelines_heading =
              decodedData.records.essentials.setup_guidelines_heading;

            _this.client_data.lab_training =
              decodedData.records.essentials.lab_training_options;
            _this.client_data.lab_training_status =
              decodedData.records.lab_training_status;

            _this.client_data.schedule_assessment_title =
              decodedData.records.schedule_assessment_title;

            _this.client_data.schedule_assessment_description =
              decodedData.records.schedule_assessment_description;

            _this.client_data.schedule_request_status =
              decodedData.records.schedule_request_status;
            _this.client_data.schedule_request =
              decodedData.records.schedule_request;

            _this.client_data.schedule_request_heading =
              decodedData.records.schedule_request_heading || "";
            _this.client_data.self_assessment_heading =
              decodedData.records.self_assessment_heading || "";
            _this.client_data.self_assessment_content =
              decodedData.records.self_assessment_content || "";
          } else {
            _this.$toast.error(data.message, {
              position: "top-right",
              duration: 5000,
            });
            _this.$router.push({
              name: "all_clients",
            });
          }
        })
        .catch((response) => {
          console.log("catch", response);
          _this.$router.push({
            name: "all_clients",
            params: { errorMsg: response.data.error },
          });
        });
    },
    onFileChange(e, file_for) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0], file_for);
    },
    createImage(file, file_for) {
      var reader = new FileReader();

      reader.onload = (e) => {
        if (file_for == "banner") {
          this.client_data.banner_image = e.target.result;
        }
        if (file_for == "logo") {
          this.client_data.logo = e.target.result;
        }
        if (file_for == "work_from_office_icon") {
          this.client_data.new_work_from_office_icon = true;
          this.client_data.work_area_details.Office.icon = e.target.result;
        }
        if (file_for == "work_from_home_icon") {
          this.client_data.new_work_from_home_icon = true;
          this.client_data.work_area_details.Home.icon = e.target.result;
        }
        if (file_for == "work_from_anywhere_icon") {
          this.client_data.new_work_from_anywhere_icon = true;
          this.client_data.work_area_details.Anywhere.icon = e.target.result;
        }
        if (file_for == "work_from_lab_icon") {
          this.client_data.new_work_from_lab_icon = true;
          this.client_data.work_area_details.Lab.icon = e.target.result;
        }
        if (file_for == "work_from_travel_icon") {
          this.client_data.new_work_from_travel_icon = true;
          this.client_data.work_area_details.Travel.icon = e.target.result;
        }
      };

      reader.readAsDataURL(file);
    },
    async toggleHeaderMenu(type, status) {
      if (status == 1) {
        this.client_data.site_menu_details[type].status = status;

        // Hide the other menu if it is currently shown
        if (type === "RequestAnEvaluation") {
          this.client_data.site_menu_details.TakeASelfAssessment.status = 0;
        } else if (type === "TakeASelfAssessment") {
          this.client_data.site_menu_details.RequestAnEvaluation.status = 0;
        }
      } else {
        const confirmComplete = await this.$refs.confirmDialogue.show({
          title: "",
          message: "Are you sure you want to hide  ?",
          okButton: "Yes",
        });
        // On Confirm
        if (confirmComplete) {
          this.client_data.site_menu_details[type].status = status;
        } else {
          let el = this.$refs[type + "_show"];
          el.click();
        }
      }
    },
    updateClientCMS() {
      var _this = this;
      _this.$validator.validateAll("addCientForm").then((isValid) => {
        if (isValid) {
          _this.$parent.$refs.fullpageloader.is_full_page_loader = true;
          if (_this.client_data.u_id) {
            let config = {
              method: "put",
              url:
                process.env.VUE_APP_API_URL +
                "/api/update-client-cms/" +
                _this.client_data.u_id,
              headers: {
                "Content-Type": "application/json",
              },
              withCredentials: true,
              data: {
                request_data: this.encodeAPIRequestWithImages(
                  _this.client_data
                ),
              },
            };
            _this
              .axios(config)
              .then(({ data }) => {
                _this.$parent.$refs.fullpageloader.is_full_page_loader = false;
                _this.$toast.success(data.message, {
                  position: "top-right",
                  duration: 5000,
                });
              })
              .catch((err) => {
                _this.$parent.$refs.fullpageloader.is_full_page_loader = false;
                if (err.response.status == 422) {
                  var err1 = "";
                  for (let x in err.response.data.errors) {
                    err1 += err.response.data.errors[x];
                    err1 += "<br>";
                  }
                  _this.$toast.error(err1, {
                    position: "top-right",
                    duration: 5000,
                  });
                } else if (err.response.status == 401) {
                  _this.tokenExpired();
                } else {
                  _this.$toast.error(err.response.data.error, {
                    position: "top-right",
                    duration: 5000,
                  });
                }
              });
          } else {
            _this.$router.push({
              name: "404",
              params: { errorMsg: "URL Not found." },
            });
          }
        } else {
          console.log("Error In Validation", _this.errors);
          const nodeList = document.querySelectorAll(".error");
          nodeList.forEach((element) => {
            if (element.style.display != "none") {
              var acc = element.closest(".accordion-collapse");
              if (acc != null) acc.classList.add("show");
            }
          });
        }
      });
    },
  },
};
</script>
